// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3p3z_","header":"Messages_header__2A7Hr"};